import React from 'react';
import PropTypes from 'prop-types';
import MultiSelectBox from '../Common/MultiSelectBox/MultiSelectBox';
import Icon from '../Common/Icon';
import Dockbar from '../Common/Dockbar/Dockbar';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';
import TaskResultMobile from './TaskResultMobile';

import './BaselineTaskListMobile.scss';

class BaselineTaskListMobile extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    onAddBaselineTaskClick = () => {
        alert("New baseline drawer");
    }

    onBaselineSelected = (id) => {
        this.props.updateParamsAndSearch("baselineId", id);
    }

    onShowTask = (id) => {
        this.props.showTask(id);
    }

    render() {
        return (
            <div>
                <LoadingIndicator isLoading={this.props.isFetchingBaselines}>
                    <div className="row no-gutters">

                        <div className="col baseline-mobile-task-list">
                            <div className="baseline-selector">

                                <MultiSelectBox
                                    name="baselines"
                                    label="Baselines"
                                    options={this.props.baselines}
                                    selectedValues={this.props.searchParams.baselineId.toString()}
                                    idField="id"
                                    valueField="name"
                                    onChange={this.onBaselineSelected}
                                    isMulti={false}
                                />
                            </div>
                            <LoadingIndicator isLoading={this.props.isFetchingTasks}>
                                <div>
                                    {this.props.baselineTasks.map(task =>
                                        <TaskResultMobile key={task.id} task={task} showTask={this.onShowTask} />
                                    )}
                                    {this.props.baselineTasks.length === 0 ?
                                        <div className="ms-2">No Results Found</div>
                                    :
                                    ""
                                    }
                                </div>
                            </LoadingIndicator>
                        </div>
                    </div>
                    <Dockbar>
                        <div className="container-fluid docked-content">
                            <button className="btn btn-light ms-2" onClick={this.props.onViewFiltersClick}><Icon name="filter" />View Filters</button> 
                            <button className="btn btn-primary float-end" onClick={() => this.onShowTask(null)}>Add Baseline Task</button>
                        </div>
                    </Dockbar>
                </LoadingIndicator>

            </div>

        );
    }
}

BaselineTaskListMobile.propTypes = {
    baselines: PropTypes.array.isRequired,
    baselineTasks: PropTypes.array.isRequired,
    isFetchingBaselines: PropTypes.bool.isRequired,
    isFetchingTasks: PropTypes.bool.isRequired,
    updateParamsAndSearch: PropTypes.func.isRequired,
    updateSearchParams: PropTypes.func.isRequired,
    searchParams: PropTypes.object.isRequired,
    showTask: PropTypes.func.isRequired,
    search: PropTypes.func.isRequired,
    departments: PropTypes.array.isRequired,
    baselineJobTitles: PropTypes.array.isRequired,
    communities: PropTypes.array.isRequired,
    phases: PropTypes.array.isRequired,
    disciplines: PropTypes.array.isRequired,
    onViewFiltersClick: PropTypes.func.isRequired
};

export default BaselineTaskListMobile;
